export const ACTIVITY_TYPES = {
  TIMELINE: "Timeline",
  FIELD_VALUE: "FieldValue",
  TASK: "Task",
  ASSIGNEE: "Assignee",
  CHECKLIST: "Checklist",
  FIELD: "Field",
  PROJECT: "Project",
  COMMENT: "Comment",
  DOCUMENT: "Document",
  CHAT_MESSAGE: "ChatMessage",
  MESSAGE: "Message",
  SECTION: "Section",
  PROJECT_MEMBER: "ProjectMember",
  PULL_REQUEST: "NeetoGithubEngine::PullRequest",
};

export const ENGAGEMENT_TYPES = {
  COMMENT: "comment",
  ACTIVITY: "activity",
};
